class Hosts {
    constructor() {
        this.title = null
        this.prevBtn = null
        this.nextBtn = null
        this.pageIndicator = null
        this.page = 1
        this.maxPage = 0
        this.count = 0

        this.locked = false

        this.title = $("#hosts-menu-title");
        this.prevBtn = $("#hosts-menu-prev-btn");
        this.nextBtn = $("#hosts-menu-next-btn");
        this.pageIndicator = $("#hosts-menu-page");

        this.count = parseInt($("#hosts-menu-count").text());
        this.maxPage = Math.ceil(this.count / 10);

        var offset = parseInt(this.pageIndicator.text());
        if (offset > 1) this.page = Math.ceil(offset / 10);
    }

    _lock() {
        this.locked = true;
    }

    _unlock() {
        this.locked = false;
    }

    previous() {
        var that = this;
        if (this._locked || this.page - 1 < 1) return;
        this._lock();

        that.page--;

        $.ajax({
            url: "/profile/get-header-hosts/", dataType: 'json', type: 'post',
            data: {page: this.page},
            success: function(data) {
                if (data && data.success != undefined && data.success) {
                    $(".hosts-menu-host").remove();
                    that.title.after(data.view);
                    $(".hosts-menu-host .marquee").each(function (k, v) {$(v).marquee();});
                    $('.hosts-menu-host').each(function() {
                        $(this).mouseover(function() {
                            $(this).find('a:eq(0)').addClass('active');
                            $(this).find('ul.dropdown-menu').css('display', 'block');
                        });

                        $(this).mouseout(function() {
                            $(this).find('a:eq(0)').removeClass('active');
                            $(this).find('ul.dropdown-menu').css('display', 'none');
                        });
                    });


                    that.pageIndicator.html(((that.page - 1) * 10 + 1) + '-' + Math.min((that.page * 10), that.count));
                    if (that.page <= 1) {
                        //if (!that.prevBtn.hasClass("disabled")) that.prevBtn.addClass("disabled");
                    }
                }
                that._unlock();
            }
        });
    }

    next() {
        var that = this;
        if (this._locked || this.page + 1 > this.maxPage) return;
        this._lock();

        that.page ++;

        $.ajax({
            url: "/profile/get-header-hosts/", dataType: 'json', type: 'post',
            data: {page: this.page},
            success: function(data) {
                if (data && data.success != undefined && data.success) {
                    $(".hosts-menu-host").remove();
                    that.title.after(data.view);
                    $(".hosts-menu-host .marquee").each(function (k, v) {$(v).marquee();});
                    $('.hosts-menu-host').each(function() {
                        $(this).mouseover(function() {
                            $(this).find('a:eq(0)').addClass('active');
                            $(this).find('ul.dropdown-menu').css('display', 'block');
                        });

                        $(this).mouseout(function() {
                            $(this).find('a:eq(0)').removeClass('active');
                            $(this).find('ul.dropdown-menu').css('display', 'none');
                        });
                    });

                    that.pageIndicator.html(((that.page - 1) * 10 + 1) + '-' + Math.min((that.page * 10), that.count));
                    if (that.page >= that.maxPage) {
                        //if (!that.nextBtn.hasClass("disabled")) that.nextBtn.addClass("disabled");
                    }
                }
                that._unlock();
            }
        });
    }
}


export { Hosts }
